import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Form, Spin, Input, Tabs, Space } from 'antd';
import { HomeOutlined, SwapOutlined, SearchOutlined, RedoOutlined, EyeOutlined } from '@ant-design/icons';
import PopupFrame from '../../component/popupFrame/popupFrame';//删除弹框
import Audit from '../../component/audit/audit';//审核彈框
import moment from 'moment';//日期格式化导包
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import Message from '../../component/message/message';
import './houseKeeping.css';
import ConfirmFrame from '../../component/confirmFrame/confirmFrame';
import SelectProgModal from '../../component/selectProgModal/selectProgModal';

const { TabPane } = Tabs;

const HouseKeeping = (props) => {

    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isAudit, setIsAudit] = useState(false);
    const [auditModel, setAuditModel] = useState({});
    const [tabIndex, setTabIndex] = useState("1");
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [searchIpModel, setSearchIpModel] = useState({});
    const [oldSearchIpModel, setOldSearchIpModel] = useState({});
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchAcademicModel, setSearchAcademicModel] = useState({});
    const [oldSearchAcademicModel, setOldSearchAcademicModel] = useState({});
    const [tablesAcademic, setTablesAcademic] = useState([]);
    const [tablesCountAcademic, setTablesCountAcademic] = useState(0);
    const [currentAcademic, setCurrentAcademic] = useState(1);
    const [pageSizeAcademic, setPageSizeAcademic] = useState(10);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [flag, setFlag] = useState("");
    const [paramSegmentList, setParamSegmentList] = useState([]);
    const [paramModel, setParamModel] = useState({});
    const [deleteTipText, setDeleteTipText] = useState("");
    const [studentModel, setStudentModel] = useState({});

    const [selectedStudentRowKeys, setSelectedStudentRowKeys] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState([]);
    const [selectedAcademicRowKeys, setSelectedAcademicRowKeys] = useState([]);
    const [selectedAcademic, setSelectedAcademic] = useState([]);
    const [deleteTipTextStudent, setDeleteTipTextStudent] = useState("");
    const [isDeleteFrameStudent, setIsDeleteFrameStudent] = useState(false);
    const [deleteTipTextAcademic, setDeleteTipTextAcademic] = useState("");
    const [isDeleteFrameAcademic, setIsDeleteFrameAcademic] = useState(false);
    const [isConfirmAcademic, setIsConfirmAcademic] = useState(false);
    const [isConfirmAcademicAll, setIsConfirmAcademicAll] = useState(false);

    const [isDeleteFrameIp, setIsDeleteFrameIp] = useState(false);
    const [isDeleteFrameAllIp, setIsDeleteFrameAllIp] = useState(false);
    const [isDeleteFrameAllAcademic, setIsDeleteFrameAllAcademic] = useState(false);
    const [tablesIp, setTablesIp] = useState([]);
    const [tablesCountIp, setTablesCountIp] = useState(0);
    const [currentIp, setCurrentIp] = useState(1);
    const [pageSizeIp, setPageSizeIp] = useState(10);

    const [selectedIPRowKeys, setSelectedIPRowKeys] = useState([]);
    const [selectedIP, setSelectedIP] = useState([]);
    const [IpModel, setIpModel] = useState({});
    const [academicModel, setAcademicModel] = useState({});
    const [isSearchProgModal, setIsSearchProgModal] = useState(false);
    const [isSearchProgAcademicModal, setIsSearchProgAcademicModal] = useState(false);

    const options = [
        { label: "Lisa Wong", value: "Lisa Wong" },
        { label: "Li Ka Shing", value: "Li Ka Shing" },
    ]

    const tableColumns = {
        studentAcctId: "student_acct_id",
        cohortYear: "cohort_year",
        inactiveDate: "inactive_date",
    }

    const tableColumnsIp = {
        partnerContactAcctId: "partner_contact_acct_id",
        inactiveDate: "inactive_date",
    }

    const tableColumnsAcademic = {
        academicStaffAcctId: "academic_staff_acct_id",
        inactiveDate: "inactive_date",
    }


    useEffect(() => {
        searchAcademic(pageSize, 1, "N");
        searchIP(pageSizeIp, 1, "N")
        searchStudent(pageSize, 1, "N")
    }, []);


    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const searchChangeIp = (key, value) => {
        messageShowHandler();
        setSearchIpModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const searchChangeAcademic = (key, value) => {
        messageShowHandler();
        setSearchAcademicModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    //查询
    const searchStudent = (pageSizeNew, current, flag, isShowMsg, newModel) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();
        let model = {};
        if ("Y" === flag) {//翻頁
            model = oldSearchModel;
        } else {
            if (newModel) {
                model = JSON.parse(JSON.stringify({ ...searchModel, ...newModel }));
            } else {
                model = JSON.parse(JSON.stringify(searchModel));
            }
        }
        model.pageSize = pageSizeNew;
        model.startRow = (current - 1) * pageSizeNew;
        model.page = current;
        model.progCodeList = Config.userInfo?.progCodeList
        model.cohortYear = Config.cohort?.cohortYear
        setIsLoad(true);
        setSpinInfo("Searching..." );
        Base.callBackApi("student/removeStudentList", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data.object.list && isShowMsg) {
                    errFrameShow("info", "No record is founed.");
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(current);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    //查询公司
    const searchIP = (pageSizeNew, current, flag, isShowMsg, newModel) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();
        let model = {};
        if ("Y" === flag) {//翻頁
            model = oldSearchIpModel;
        } else {
            if (newModel) {
                model = JSON.parse(JSON.stringify({ ...searchIpModel, ...newModel }));
            } else {
                model = JSON.parse(JSON.stringify(searchIpModel));
            }
        }
        model.pageSize = pageSizeNew;
        model.startRow = (current - 1) * pageSizeNew;
        model.page = current;
        model.progCodeList = Config.userInfo?.progCodeList
        setIsLoad(true);
        setSpinInfo("Searching..." );
        Base.callBackApi("partnerContact/removeIpList", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data.object.list && isShowMsg) {
                    errFrameShow("info", "No record is founed.");
                }
                if ("N" === flag) {
                    setOldSearchIpModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCountIp(data?.object?.total ?? 0);
                setTablesIp(data?.object?.list ?? []);
                setCurrentIp(current);
                setPageSizeIp(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchAcademic = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchAcademicModel;
        } else if ("reset" === flag) {
            model = {}
        } else {
            model = searchAcademicModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        model.progCodeList = Config.userInfo?.progCodeList
        setIsLoad(true);
        setSpinInfo("Searching...");
        Base.callBackApi("academicStaff/removeAcademicList", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", 'No record is founed.');
                }
                if ("N" === flag) {
                    setOldSearchAcademicModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCountAcademic(data?.object?.total ?? 0);
                setTablesAcademic(data?.object?.list ?? []);
                setCurrentAcademic(currentPageNew);
                setPageSizeAcademic(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    const resetIp = () => {
        messageShowHandler();
        setSearchIpModel({});
        setOldSearchIpModel({});
        setTablesCountIp(0);
        setTablesIp([]);
        setPageSizeIp(10);
    }

    const resetAcademic = () => {
        messageShowHandler();
        setSearchAcademicModel({});
        setOldSearchAcademicModel({});
        setTablesCountAcademic(0);
        setTablesAcademic([]);
        setPageSizeAcademic(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        messageShowHandler();
        clearSelect();
        if (key) {
            if (key === "3") {
                setSearchModel({
                    activeInd: 'N'
                });
                setOldSearchModel({});
                setTabIndex("3");
            } else if (key === "2") {
                setSearchModel({
                    activeInd: 'N'
                });
                setOldSearchModel({});
                setTabIndex("2");
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                searchStudent(pageSize, current, "Y");
            }
        }
    }

    const initForm = (model = {}) => {
        form.resetFields();
        let academicSupervisor = [];
        if (model.academicSupervisor) {
            academicSupervisor = ['Lisa Wong', 'Li Ka Shing'];
        }
        form.setFieldsValue({
            wilProgrammeCode: model.wilProgrammeCode ?? '',
            wilProgrammeName: model.wilProgrammeName ?? '',
            cohortYear: model.cohortYear ?? '',
            programmeLeader: model.programmeLeader ?? '',
            moduleConvener: model.moduleConvener ?? '',
            academicSupervisor: academicSupervisor,
            programmeDesc: model.programmeDesc ?? '',
            status: model.status ?? '',
            receiveNotification: model.receiveNotification ?? '',
            handleStudentJobApproval: model.handleStudentJobApproval ?? ''
        });
    }


    const deleteFrameClose = (state) => {
        if(state){
            deleteData();
        }
        setIsDeleteFrame(false);
    }

    const deleteFrameCloseAll = (state) => {
        if(state){
            deleteStudentDataAll();
        }
        setIsDeleteFrameStudent(false);
    }

    const deleteFrameCloseIp = (state) => {
        if(state){
            deleteDataIp();
        }
        setIsDeleteFrameIp(false);
    }

    const deleteFrameCloseAllIp = (state) => {
        if(state){
            deleteIpDataAll();
        }
        setIsDeleteFrameAllIp(false);
    }

    const confirmAcademicClose = (state) => {
        if(state){
            deleteDataAcademic();
        }
        setIsDeleteFrameAcademic(false);
    }
    
    const confirmAcademicCloseAll = (state) => {
        if(state){
            deleteAcademicDataAll();
        }
        setIsDeleteFrameAllAcademic(false);
    }

    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo("Data is processing...");
        let model = studentModel;
        model.menuFuncId = Config.funcInfo.funcId;
        model.studentIds = studentModel.studentId+"";
        model.studentUserIds = studentModel.userId+"";
        Base.callBackApi("houseKeeping/houseKeep", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setSearchModel({});
                searchStudent(pageSize, current, "Y");
                errFrameShow("success", "Archive successfully.");
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const deleteStudentDataAll = () => {
        setIsLoad(true);
        setSpinInfo("Data is processing...");
        let model = {}; 
        model.studentIds= selectedStudent && selectedStudent.map(item => item.studentId.toString()).join(",");
        model.studentUserIds= selectedStudent && selectedStudent.map(item => item.userId.toString()).join(",");
        Base.callBackApi("houseKeeping/houseKeep", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setSearchModel({});
                searchStudent(pageSize, current, "Y");
                errFrameShow("success", "Archive successfully.");
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const deleteDataIp = () => {
        setIsLoad(true);
        setSpinInfo("Data is processing...");
        let model = IpModel;
        model.menuFuncId = Config.funcInfo.funcId;
        model.ipAcctIds = IpModel.partnerContactAcctId+"";
        model.ipUserIds = IpModel.userId+"";
        Base.callBackApi("houseKeeping/houseKeepIp", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setSearchModel({});
                searchIP(pageSizeIp, currentIp, "Y");
                errFrameShow("success", "Archive successfully.");
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const deleteIpDataAll = () => {
        setIsLoad(true);
        setSpinInfo("Data is processing...");
        let model = {}; 
        model.ipAcctIds= selectedIP && selectedIP.map(item => item.partnerContactAcctId.toString()).join(",");
        model.ipUserIds= selectedIP && selectedIP.map(item => item.userId.toString()).join(",");
        (model);
        Base.callBackApi("houseKeeping/houseKeepIp", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setSearchModel({});
                searchIP(pageSizeIp, currentIp, "Y");
                errFrameShow("success", "Archive successfully.");
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const deleteDataAcademic = () => {
        setIsLoad(true);
        setSpinInfo("Data is processing...");
        let model = academicModel;
        model.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("houseKeeping/houseKeepAcademic", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setSearchAcademicModel({});
                searchAcademic(pageSizeAcademic, currentAcademic, "Y");
                errFrameShow("success", "Archive successfully.");
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const deleteAcademicDataAll = () => {
        setIsLoad(true);
        setSpinInfo("Data is processing...");
        let model = {
            academicStaffModelList: selectedAcademic,
        }; 
        Base.callBackApi("houseKeeping/houseKeepAcademicAll", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setSearchAcademicModel({});
                searchAcademic(pageSizeAcademic, currentAcademic, "Y");
                errFrameShow("success", "Archive successfully.");
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                searchStudent(pageSize, 1, "N", true);
            }
        }
    }

    const handleTableChangeIp = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumnsIp[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumnsIp[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchIpModel.orderBy) {
            if (orderBy !== searchIpModel.orderBy) {
                searchIpModel.orderBy = orderBy;
                searchIP(pageSizeIp, 1, "N", true);
            }
        }
    }

    const handleTableChangeAcademic = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumnsAcademic[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumnsAcademic[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchAcademicModel.orderBy) {
            if (orderBy !== searchAcademicModel.orderBy) {
                searchAcademicModel.orderBy = orderBy;
                searchAcademic(pageSizeAcademic, 1, "N", true);
            }
        }
    }

    const deleteOne = (model, e) => {
        e.stopPropagation();
        setParamModel(model)
        setStudentModel(model);
        setIsDeleteFrame(true);
        setDeleteTipText("Student ID" + ":" + model.studentAcctId + "")
    }

    const removeAllStudent = () => {
        if(selectedStudent.length>0){
            const result = selectedStudent && selectedStudent.map(item => item.studentAcctId).join(', ');
            setDeleteTipTextStudent("Student ID"+ ":" + result + "")
            setIsDeleteFrameStudent(true);
        }
    }

    const deleteOneIp = (model, e) => {
        e.stopPropagation();
        setParamModel(model)
        setIpModel(model);
        setIsDeleteFrameIp(true);
        setDeleteTipText("Contact ID" + ":" + model.partnerContactAcctId + "")
    }

    const deleteOneAcademic = (model, e) => {
        e.stopPropagation();
        setAcademicModel(model);
        setIsDeleteFrameAcademic(true);
        setDeleteTipTextAcademic("Academic ID" + ":" + model.academicStaffAcctId + "")
    }

    const removeAllIp = () => {
        (selectedIP);
        if(selectedIP.length>0){
            const result = selectedIP && selectedIP.map(item => item.partnerContactAcctId).join(', ');
            setDeleteTipTextStudent("Contact ID"+ ":" + result + "")
            setIsDeleteFrameAllIp(true);
        }
    }

    const removeAllAcademic = () => {
        if(selectedAcademic.length>0){
            const result = selectedAcademic && selectedAcademic.map(item => item.academicStaffAcctId).join(', ');
            setDeleteTipTextAcademic("Academic ID"+ ":" + result + "")
            setIsDeleteFrameAllAcademic(true);
        }
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        searchStudent(pageSizeNew, currentNew, "Y");
    }
    const onChangeAcademic = (currentNew, pageSizeNew) => {
        searchAcademic(pageSizeNew, currentNew, "Y");
    }
    const onChangeIp = (currentNew, pageSizeNew) => {
        searchIP(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        searchStudent(pageSizeNew, 1, "Y");
    }
    const onShowSizeChangeAcademic = (currentNew, pageSizeNew) => {
        searchAcademic(pageSizeNew, 1, "Y");
    }

    const onShowSizeChangeIp = (currentNew, pageSizeNew) => {
        searchIP(pageSizeNew, 1, "Y");
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const onSelectChange = (selectedRowKeys, selectedRows) => {
        setSelectedRowKeys(selectedRowKeys);
        setCheckboxState(selectedRows);
    }

    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([])
    }

    
    const closeSearchProgModal = (flag, cohortProg) => {
        if (flag) {
            setSearchModel(model => {
                return { ...model, ...{ progTitle: cohortProg.progTitle, progCode: cohortProg.progCode, } };
            });
        }
        setIsSearchProgModal(false);
    }

    const closeSearchProgAcademicModal = (flag, cohortProg) => {
        if (flag) {
            setSearchAcademicModel(model => {
                return { ...model, ...{ progTitle: cohortProg.progTitle, progCode: cohortProg.progCode, } };
            });
        }
        setIsSearchProgAcademicModal(false);
    }

    const columns = [
        {
            title: 'Student ID',
            dataIndex: 'studentAcctId',
            className: 'tableWidth10',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'studentAcctId') },
        },
        {
            title: "Student",
            dataIndex: 'firstName',
            className: 'tableWidth8',
            render: (text, record) => text + ' ' + record.lastName
        },
        {
            title: "Email",
            dataIndex: 'email',
            className: 'tableWidth8',
        },
        {
            title: 'Admission Year',
            dataIndex: 'cohortYear',
            className: 'tableWidth11',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'cohortYear') },
        },
        {
            title: 'Department',
            dataIndex: 'deptCode',
            className: 'tableWidth9',
        },
        {
            title: 'Programme Code',
            dataIndex: 'studentProgrammeCode',
            className: 'tableWidth13',
        },
        {
            title: 'Programme Name',
            dataIndex: 'studentProgramme',
            className: 'tableWidth13',
        },
        {
            title: 'Study Year Entry',
            dataIndex: 'studyYearEntry',
            className: "tableWidth12",
        },
        {
            title: 'Status',
            dataIndex: 'activeInd',
            className: 'tableWidth6',
            render: (text) => ContextHandler.getMapValueTransalation('activeTransalation', text)
        },
        {
            title: 'Inactive Date',
            dataIndex: 'inactiveDate',
            className: 'tableWidth11',
            render: text => text ? moment(text).format(Config.dateFormat5) : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'inactiveDate') },
        },
        {
            title: "Operation",
            dataIndex: '',
            fixed: 'right',
            width: 150,
            className: ' sysControls',
            render: (text, record) => <div className='operation'>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e)} hidden={Config.funcInfo.canDelete === "N"}><SwapOutlined /> Archive</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> Log</div>
            </div>
        },
    ];

    const columnsTwo = [
        {
            title: 'Company Name',
            dataIndex: 'companyName',
            className: 'tableWidth15',
        },
        {
            title: "Contact ID",
            dataIndex: 'partnerContactAcctId',
            className: 'tableWidth14',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'partnerContactAcctId') },
        },
        {
            title: "Contact Title",
            dataIndex: 'contactTitle',
            className: 'tableWidth12',
        },
        {
            title: 'Contact Name',
            dataIndex: 'contactName',
            className: 'tableWidth15',
        },
        {
            title: "Contact Email",
            dataIndex: 'contactEmail',
            className: 'tableWidth18',
        },
        {
            title: "Status",
            dataIndex: 'activeInd',
            className: 'tableWidth10',
            render: (text) => ContextHandler.getMapValue('activeMap', text)
        },
        {
            title: "Inactive Date",
            dataIndex: 'inactiveDate',
            className: 'tableWidth14',
            render: text => text ? moment(text).format(Config.dateFormat5) : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'inactiveDate') },
        },
        {
            title: "Operation",
            dataIndex: '',
            fixed: 'right',
            width: 150,
            className: ' sysControls',
            render: (text, record) => <div className='operation'>
                <div className='sysDelete' onClick={(e) => deleteOneIp(record, e)} hidden={Config.funcInfo.canDelete === "N"}><SwapOutlined /> Archive</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> Log</div>
            </div>
        },
    ];

    const columnsAcademic = [
        {
            title: 'Academic ID',
            dataIndex: 'academicStaffAcctId',
            className: 'tableWidth17',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'academicStaffAcctId') },
        },
        {
            title: 'Academic Name',
            dataIndex: 'staffName',
            className: 'tableWidth22',
            render: (text, record) => record.firstName + ' ' + record.lastName
        },
        {
            title: "Staff Saluation",
            dataIndex: 'staffSaluation',
            className: 'tableWidth16',
        },
        {
            title: "Email",
            dataIndex: 'email',
            className: 'tableWidth16',
        },
        {
            title: "Status",
            dataIndex: 'activeInd',
            className: 'tableWidth12',
            render: (text) => ContextHandler.getMapValue('activeMap', text)
        },
        {
            title: "Inactive Date",
            dataIndex: 'inactiveDate',
            className: 'tableWidth14',
            render: (text) => text != null ? moment(text).format(Config.dateFormat5) : null,
            sorter: (a, b) => { return Base.sortMethod(a, b, 'inactiveDate') },
        },
        {
            title: "Operation",
            dataIndex: '',
            fixed: 'right',
            width: 150,
            className: ' sysControls',
            render: (text, record) => <div className='operation'>
                <div className='sysDelete' onClick={(e) => deleteOneAcademic(record, e)} hidden={Config.funcInfo.canDelete === "N"}><SwapOutlined /> Archive</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> Log</div>
            </div>
        },
    ];

    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
    };

    const onSelectStudentChange = (selectedRowKeys, selectedRows) => {
        setSelectedStudentRowKeys(selectedRowKeys);
        setSelectedStudent(selectedRows);
    }

    const rowStudentSelection = {
        selectedRowKeys: selectedStudentRowKeys,
        onChange: onSelectStudentChange,
    };

    const onSelectAcademicChange = (selectedRowKeys, selectedRows) => {
        setSelectedAcademicRowKeys(selectedRowKeys);
        setSelectedAcademic(selectedRows);
    }

    const rowAcademicSelection = {
        selectedRowKeys: selectedAcademicRowKeys,
        onChange: onSelectAcademicChange,
    };

    const onSelectIPChange = (selectedRowKeys, selectedRows) => {
        setSelectedIPRowKeys(selectedRowKeys);
        setSelectedIP(selectedRows);
    }

    const rowIPSelection = {
        selectedRowKeys: selectedIPRowKeys,
        onChange: onSelectIPChange,
        preserveSelectedRowKeys: true,
    };
    

    return (
        <div id="container" className="template houseKeeping">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} content={"Are you sure to Archive?"}/> : null}
                    {isDeleteFrameStudent ? <PopupFrame close={deleteFrameCloseAll} deleteTipText={deleteTipTextStudent} content={"Are you sure to Archive?"}/> : null}
                    {isDeleteFrameIp ? <PopupFrame close={deleteFrameCloseIp} deleteTipText={deleteTipText} content={"Are you sure to Archive?"}/> : null}
                    {isDeleteFrameAllIp ? <PopupFrame close={deleteFrameCloseAllIp} deleteTipText={deleteTipTextStudent} content={"Are you sure to Archive?"}/> : null}
                    {isDeleteFrameAcademic ? <ConfirmFrame close={confirmAcademicClose} 
                        deleteTipText={deleteTipTextAcademic}
                        tipText={"Before archive, please make sure the academic user is not used in Programme Parameters."} 
                        content={"Are you sure to archive?"}/>
                    : null}
                    {isDeleteFrameAllAcademic ? <ConfirmFrame close={confirmAcademicCloseAll} 
                        deleteTipText={deleteTipTextAcademic}
                        tipText={"Before archive, please make sure the academic user is not used in Programme Parameters."} 
                        content={"Are you sure to archive?"}/>
                    : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab="Student">
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle">Student ID</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder="Student ID" value={searchModel.studentAcctId}
                                            onChange={(e) => searchChange('studentAcctId', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? searchStudent(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Student Name</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder="Student Name" value={searchModel.studentName}
                                            onChange={(e) => searchChange('studentName', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? searchStudent(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                {/* <div className='sysCol'>
                                    <div className="sysTitle">Programme</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder="Programme" value={searchModel.progTitle}
                                            onChange={(e) => searchChange('progTitle', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? searchStudent(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div> */}
                                <div className='sysCol'>
                                    <div className="sysTitle">Programme Code</div>
                                    <div className="sysButtonSearchInput">
                                        <Input type="text" value={searchModel.progCode || ''} disabled
                                            placeholder='Programme Code'
                                            onKeyDown={(e) => e.key === "Enter" ? searchStudent(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('progCode', e.target.value)} />
                                    </div>
                                    <Button className="sysBtn btnBlue" onClick={() => { setIsSearchProgModal(true) }}>Select</Button>
                                    <div style={{ marginLeft: '10px' }}>{searchModel.progTitle}</div>
                                </div>
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" onClick={() => searchStudent(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>Search</Button>
                                    <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>Reset</Button>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="buttonRelative">
                                <Button className='sysBtn btnBlue' type="primary" onClick={() => removeAllStudent()} hidden={Config.funcInfo.canDelete === "N"} icon={<SwapOutlined />}>Batch Archive</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    rowSelection={rowStudentSelection} //选择
                                    rowKey="studentId"
                                    scroll={{ x: 1500 }}
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChange,            //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                                        total: tablesCount,             //总共多少条数据
                                        current: current,         //当前页
                                        pageSize: pageSize,       //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane tab={"Industry Partner"} key="2" forceRender={true}>
                        <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle">Contact ID</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder="Contact ID" value={searchIpModel.partnerContactAcctId}
                                            onChange={(e) => searchChangeIp('partnerContactAcctId', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? searchIP(pageSizeIp, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Contact Name</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder="Contact Name" value={searchIpModel.contactName}
                                            onChange={(e) => searchChangeIp('contactName', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? searchIP(pageSizeIp, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" onClick={() => searchIP(pageSizeIp, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>Search</Button>
                                    <Button className="sysBtn" onClick={resetIp} icon={<RedoOutlined />}>Reset</Button>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="buttonRelative">
                                <Button className='sysBtn btnBlue' type="primary" onClick={() => removeAllIp()} hidden={Config.funcInfo.canDelete === "N"} icon={<SwapOutlined />}>Batch Archive</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    rowSelection={rowIPSelection} //选择
                                    rowKey="partnerContactId"
                                    scroll={{ x: 1350 }}
                                    columns={columnsTwo} //列名
                                    dataSource={tablesIp} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChangeIp,            //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChangeIp,    //每页显示多少条数据方法
                                        total: tablesCountIp,             //总共多少条数据
                                        current: currentIp,         //当前页
                                        pageSize: pageSizeIp,       //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChangeIp}
                                />
                            </div>
                        </TabPane>
                        <TabPane tab={"Academic"} key="3" >
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle">Academic ID</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchAcademicModel.academicStaffAcctId || ''}
                                            placeholder="Academic ID"
                                            onKeyDown={(e) => e.key === "Enter" ? searchAcademic(pageSizeAcademic, 1, "N", true) : null}
                                            onChange={(e) => searchChangeAcademic('academicStaffAcctId', e.target.value)} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Academic Name</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder="Academic Name" value={searchAcademicModel.staffName}
                                            onChange={(e) => searchChangeAcademic('staffName', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? searchAcademic(pageSizeAcademic, 1, "N", true) : null} />
                                    </div>
                                </div>
                                {/* <div className='sysCol'>
                                    <div className="sysTitle">Programme</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder="Programme" value={searchAcademicModel.progTitle}
                                            onChange={(e) => searchChangeAcademic('progTitle', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? searchAcademic(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div> */}
                                <div className='sysCol'>
                                    <div className="sysTitle">Programme Code</div>
                                    <div className="sysButtonSearchInput">
                                        <Input type="text" value={searchAcademicModel.progCode || ''} disabled
                                            placeholder='Programme Code'
                                            onKeyDown={(e) => e.key === "Enter" ? searchAcademic(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChangeAcademic('progCode', e.target.value)} />
                                    </div>
                                    <Button className="sysBtn btnBlue" onClick={() => { setIsSearchProgAcademicModal(true) }}>Select</Button>
                                    <div style={{ marginLeft: '10px' }}>{searchAcademicModel.progTitle}</div>
                                </div>
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" onClick={() => searchAcademic(pageSizeAcademic, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>Search</Button>
                                    <Button className="sysBtn" onClick={resetAcademic} icon={<RedoOutlined />}>Reset</Button>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="buttonRelative">
                                <Button className='sysBtn btnBlue' type="primary" onClick={() => removeAllAcademic()} hidden={Config.funcInfo.canInsert === "N"} icon={<SwapOutlined />}>Batch Archive</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    rowSelection={rowAcademicSelection} //选择
                                    rowKey="academicStaffId"
                                    scroll={{ x: 1200 }}
                                    columns={columnsAcademic} //列名
                                    dataSource={tablesAcademic} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,         //是否显示可以设置几条一页的选项
                                        onChange: onChangeAcademic,            //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChangeAcademic,    //每页显示多少条数据方法
                                        total: tablesCountAcademic,             //总共多少条数据
                                        current: currentAcademic,         //当前页
                                        pageSize: pageSizeAcademic,       //每页显示多少条数据
                                        defaultCurrent: 1,        //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChangeAcademic}
                                />
                            </div>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
            {isSearchProgModal && <SelectProgModal onClose={closeSearchProgModal} progModel={searchModel} />}
            {isSearchProgAcademicModal && <SelectProgModal onClose={closeSearchProgAcademicModal} progModel={searchAcademicModel} />}
        </div>
    )

}

export default HouseKeeping;